import { Actions } from '../../interfaces'

import { SaleOrder } from '@/entities/sales'
import create from './create'
import fetch from './fetch'
import fetchLite from './fetchLite'
import update from './update'
import find from './find'

export const actions: Actions = {
  create,
  fetch,
  fetchLite,
  update,
  find,
}

export default {
  Model: { SaleOrder },
  actions: { [SaleOrder.name]: actions },
}
